export default {
  site_name: '97影视',
  site_slogan: '追剧不等待，精彩即刻来',
  home: '首页',
  category: '分类浏览',
  about: '关于我们',
  search: '搜索电视剧...',
  hot_recommend: '热播推荐',
  chinese_drama: '国产剧精选',
  korean_drama: '韩剧专区',
  latest_update: '最新更新',
  view_all: '查看全部',
  play_now: '立即观看',
  episode_list: '分集列表',
  you_may_like: '猜你喜欢',
  brand_intro: '品牌介绍',
  user_reviews: '用户口碑',
  contact_us: '联系我们',
  not_found: '剧集未找到',
};